import { getValue } from '@utils/lodash';
import './index.scss';
export default function AuditTable(props: any) {
	return (
		<div className="dashboard-table">
			<h3 className="table-heading">{props.tableData.title}</h3>
			<div className="table-wrapper rounded-top">
				<table className="table-section w-100">
					<thead>
						<tr>
							<th>Nature</th>
							<th>Total Count</th>
							<th>Open</th>
							<th>Closed</th>
							<th>Score</th>
						</tr>
					</thead>
					<tbody>
						{getValue(props, `tableData`, []).map(
							(eachRow: any, index: number) => {
								return (
									<tr key={index}>
										<td>{getValue(eachRow, `nature`, '')}</td>
										<td>
											{getValue(
												eachRow,
												`[${getValue(eachRow, `nature`, '')}].total_count`,
												0
											)}
										</td>
										<td>
											{getValue(
												eachRow,
												`[${getValue(eachRow, `nature`, '')}].open.count`,
												0
											)}
										</td>
										<td>
											{getValue(
												eachRow,
												`[${getValue(eachRow, `nature`, '')}].closed.count`,
												0
											)}
										</td>
										<td>
											{getValue(
												eachRow,
												`[${getValue(eachRow, `nature`, '')}].score`,
												0
											)}
										</td>
									</tr>
								);
							}
						)}
					</tbody>
				</table>
			</div>
		</div>
	);
}
